<template>
  <div>
    <div v-for="(item, index) in contextOther" :key="item.id">
      <div v-if="item.type === 'transport'" class="px-2">
        <v-row justify="center" no-gutters class="flex-nowrap">
          <v-col cols="12">
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.bill_description"
                  :label="$t('delegation.form.fields.other.billDescription.name')"
                  :error-messages="contextErrors[index].bill_description"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                  v-model="item.payment_type_id"
                  :items="payment_types"
                  item-text="name"
                  item-value="id"
                  :label="$t('delegation.form.fields.other.paymentType.name')"
                  :clearable="$store.state.Delegation.readonly !== true"
                  :error-messages="contextErrors[index].payment_type_id"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="item.bill_number"
                  :label="$t('delegation.form.fields.other.billNumber.name')"
                  :error-messages="contextErrors[index].bill_number"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="3">
                <date-picker
                  :label="$t('delegation.form.fields.other.billDate.name')"
                  :model.sync="item.bill_date"
                  :dateValidation="contextErrors[index].bill_date"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" :md="!!item.type_id && transport_types.find(v => v.id === item.type_id).isVehicleTypeRequired ? 4 : 6">
                <v-select
                  v-model="item.type_id"
                  :label="$t('delegation.form.fields.other.type.name')"
                  :items="transport_types"
                  item-text="name"
                  :error-messages="contextErrors[index].type_id"
                  item-value="id"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="2" v-if="!!item.type_id && transport_types.find(v => v.id === item.type_id).isVehicleTypeRequired">
                <v-autocomplete
                  v-model="item.vehicle_type_id"
                  :items="vehicleTypes"
                  item-text="name"
                  item-value="id"
                  :label="$t('delegation.form.fields.vehicleType.name')"
                  :clearable="$store.state.Delegation.readonly !== true"
                  :error-messages="!!item.vehicle_type_id ? [] : [$t('global.error.required')]"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="8" md="2">
                <AmountInput
                  :error-messages="contextErrors[index].amount_in_currency"
                  :model.sync="item.amount_in_currency"
                  :label="$t('global.grossAmount')"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="4" md="1">
                <currency-select
                  :model.sync="item.currency"
                  :validation-message="contextErrors[index].currency"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="3">
                <ajax-single-file
                  :accept="$store.getters['Delegation/allowedAttachmentFileFormat']"
                  :items="fileProperties(item.file_id)"
                  :model.sync="item.file_id"
                  v-on:fileUploaded="addFileToDelegationFiles"
                  v-on:fileRemoved="removeFileFromDelegationFiles"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="item.is_invoice_for_employer"
                  :label="$t('delegation.form.fields.invoiceForEmployer.name')"
                  :readonly="$store.state.Delegation.readonly === true"
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      {{ $t("delegation.form.fields.invoiceForEmployer.tooltip") }}
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">info</v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="8" md="2" v-if="item.is_invoice_for_employer">
                <AmountInput
                  :error-messages="contextErrors[index].net_amount_in_currency"
                  :model.sync="item.net_amount_in_currency"
                  :label="$t('global.netAmount')"
                  :readonly="$store.state.Delegation.readonly === true"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-spacer />
          <v-col class="d-flex align-center justify-center" v-if="clearable">
            <v-tooltip top class="hidden-sm-and-down">
              {{ $t("global.removeItem") }}
              <template #activator="{on}">
                <v-btn icon v-on="on" @click="removeOther(item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-btn class="hidden-md-and-up" @click="removeOther(item)" v-if="clearable">
          {{ $t("global.removeItem") }}
        </v-btn>
        <v-divider class="mb-2" v-if="contextOther.indexOf(item) !== contextOther.length - 1" />
      </div>
    </div>
  </div>
</template>

<script>
import CurrencySelect from "../../../CustomInputComponents/CurrencySelect.vue";
import DatePicker from "../../../CustomInputComponents/DatePicker.vue";
import PaymentTypes from "../../../../staticData/OtherSummaryPaymentTypes";
import OtherTransportTypes from "../../../../staticData/OtherTransportTypes";
import AjaxSingleFile from "../../../CustomInputComponents/AjaxSingleFile.vue";
import AmountInput from "../../../CustomInputComponents/AmountInput.vue";
import { vehicleTypes } from "../../../../staticData/OtherTransportTypes";

export default {
  name: "SimpleOtherTransportList",
  props: {
    modelOther: {
      required: true
    },
    clearable: {
      required: false,
      default: false
    }
  },
  components: { AjaxSingleFile, DatePicker, CurrencySelect, AmountInput },
  methods: {
    removeOther(item) {
      this.$emit("removeOtherItem", item);
      this.removeFileFromDelegationFiles(item);
    },
    addFileToDelegationFiles(item) {
      const newItem = item;
      newItem.description = this.$t("delegation.form.fileAttachmentDescription.otherTransport");
      newItem.category = "transport";
      this.$store.dispatch("Delegation/addFile", newItem);
    },
    removeFileFromDelegationFiles(item) {
      this.$store.dispatch("Delegation/removeFile", item.id);
    },
    fileProperties(fileId) {
      let temp = this.$store.getters["Delegation/delegationEdited"].file.find(function(element) {
        return element.id === fileId;
      });
      if (typeof temp !== "undefined") {
        return [temp];
      }
      return [];
    }
  },
  computed: {
    vehicleTypes,
    payment_types: PaymentTypes,
    transport_types: OtherTransportTypes,
    contextOther: {
      set(value) {
        this.$emit("update:modelOther", value);
      },
      get() {
        return this.modelOther;
      }
    },
    contextErrors() {
      return this.$store.getters["Delegation/delegationErrors"].other;
    }
  }
};
</script>

<style scoped></style>
